module.exports = __webpack_public_path__ + "static/img/Frame 1944.cb07a91.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark-live/mobile/Frame 1944.png
// module id = kuXn
// module chunks = 12